export const environment = {
  production: true,
  apiUrl: 'https://fitness-api.rebati.net',
  // Add more environment variables here if needed
};
